<template>
    <!-- <teleport to="body"> -->
    <div class="modal modal-lg" data-bs-backdrop="static" :class="{ 'd-block': modelValue }" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Show additional columns</h5>
                    <button @click="hide()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">

                    <ul class="list-group list-group-flus" v-for="state, section in sectionCheckboxState">
                        <li class="list-group-item">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" 
                                :id="'section_' + section"
                                :indeterminate="state.indeterminate"
                                :disabled="state.disabled"
                                 
                                  :checked="!state.indeterminate && state.checked" @click="checkSection(section)"                                 
                                />
                                <label class="form-check-label" :for="'section_' + section">{{ glabels[section] }}</label>
                            </div>
                        </li>

                        <ul class="ms-5 list-group list-group-flus">
                            <li v-for="field in groups[section]" class="list-group-item">
                                <div class="form-check">
                                    <input class="form-check-input"
                                    type="checkbox"
                                     :disabled="fixed.includes(field)"
                                      :checked="selected.includes(field) || chosen.includes(field)"
                                       :id="field" :value="field" :name="field"
                                        @change="checkField(field)" />
                                    <label class="form-check-label" :for="field"> {{ lookupField(field)?.name }}</label>
                                </div>

                            </li>

                        </ul>


                    </ul>

                </div>

                <div class="modal-footer">
                    <button @click="chosen.splice(0);" type="button" class="btn btn-md btn-secondary" data-bs-dismiss="modal">Clear selections</button>
                    <button @click="hide()" type="button" class="btn btn-primary">Close</button>
                </div>

            </div>
        </div>
    </div>
    <div v-if="modelValue" class="modal-backdrop fade show"></div>
    <!-- </teleport> -->
</template>
  
<script>
import { simpleGroupBy } from '../lib/util';
import { visible_sections } from '../lib/project';

export default {
    props: ["modelValue", 'fields', 'choices', 'query'],
    data() {
        return {
            visible: this.modelValue,
            chosen: this.choices,

            sections: visible_sections,
        };
    },

    methods: {
        hide() {
            this.$emit("update:modelValue", false);
        },
        show() {
            this.$emit("update:modelValue", true);
        },
        lookupField(key) {
            return this.fields.find(field => field.label === key);
        },
        checkSection(section) {
            if (this.sectionCheckboxState[section].indeterminate || !this.sectionCheckboxState[section].checked) {
                this.checkAll(section);
            }
            else {
                this.checkNone(section);
            }
        },
        checkField(field) {
            if (!this.selected.includes(field)) {
                this.chosen.push(field);
            } else if (this.chosen.includes(field)) {
                let index = this.chosen.findIndex(x => x === field);
                this.chosen.splice(index, 1);
            }

        },
        checkAll(section) {
            this.groups[section].forEach(field => {
                if (!this.selected.includes(field)) {
                    this.chosen.push(field);
                }
            })
        },
        checkNone(section) {
            this.groups[section].forEach(field => {
                if (this.chosen.includes(field)) {
                    let index = this.chosen.findIndex(x => x === field);
                    this.chosen.splice(index, 1);
                }
            })
        },
    },
    computed: {
        //columns that can't be hidden
        fixed() {
            return [...new Set(['state', ...Object.keys(this.query)])];
        },
        selected() {
            return [...new Set([...this.fixed, ...this.chosen])];
        },

        sectionCheckboxState() {
            return Object.fromEntries(
                this.sections.map(section => {
                    let columns = this.groups[section];
                    let selected = columns.filter(x => this.selected.includes(x));
                    let fixed = columns.filter(x => this.fixed.includes(x));

                    let some = false, all = false;

                    if (selected.length === columns.length) {
                        all = true;
                    } else if (selected.length) {
                        some = true;
                    }

                    return [section, {
                        indeterminate: some,
                        checked: all,
                        disabled: fixed.length === columns.length,
                    }];
                }));
        },


        groupedFields() {
            return simpleGroupBy(this.fields, "section_slug");
        },
        groups() {
            return simpleGroupBy(this.fields, "section_slug", 'None', (def) => def.label);
        },

        glabels() {
            return Object.fromEntries(Object.keys(this.groupedFields).map(key => [key, this.groupedFields[key][0].section_title]));
        },
    },
    watch: {
        modelValue() {
            this.visible = this.modelValue;
        },
        choices() {
            this.chosen = this.choices;
        }
    },

};
</script>
  
<style></style>
  